import styled from 'styled-components'

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
`

export const PopupContainer = styled.div`
  background: white;
  border-radius: 12px;
  padding: 32px;
  max-width: 480px;
  width: 90%;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
`

export const Title = styled.h2`
  margin: 0 0 16px 0;
  font-size: 24px;
  font-weight: 600;
  color: #333;
  text-align: center;
`

export const Message = styled.p`
  margin: 0 0 24px 0;
  font-size: 16px;
  line-height: 1.5;
  color: #666;
  text-align: center;
`

export const ButtonsWrapper = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
`

const BaseButton = styled.button`
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  border: none;
  transition: all 0.2s ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  &:active {
    transform: translateY(0);
  }
`

export const CancelButton = styled(BaseButton)`
  background: #f5f5f5;
  color: #333;

  &:hover {
    background: #e5e5e5;
  }
`

export const ConfirmButton = styled(BaseButton)`
  background: #dc3545;
  color: white;

  &:hover {
    background: #c82333;
  }
`
